import React from 'react'
import { Trans } from 'react-i18next'

import BaseModal from 'components/Modals/BaseModal'
import { Format } from 'services/Dates'
import { getPositionName } from 'services/Utilities'
import { Card, List } from 'ui'

import { t } from 'translations'

const ScheduleTemplateDatesModal = ({ dates }) => {
  return (
    <BaseModal title={`manager.scheduleTemplates.DATES_MODAL`}>
      <Card maxHeight="30rem">
        <List className="list-group-flush">
          {Object.keys(dates).map((date, index) => (
            <List.Item key={index}>
              <div>
                <small className="text-muted">{Format(date, { outFormat: 'humanDateCompact', inFormat: 'date' })}</small>
              </div>
              {dates[date].map(({ positionId, count }) => {
                return (
                  <div key={positionId}>
                    <Trans t={t} count={count} i18nKey="manager.scheduleTemplates.DATES_MODAL.POSITION_DETAIL">
                      <b>{{ positionName: getPositionName(positionId) }}</b>
                    </Trans>
                  </div>
                )
              })}
            </List.Item>
          ))}
        </List>
      </Card>
    </BaseModal>
  )
}

export default ScheduleTemplateDatesModal
